<template>
  <div
    class="d-flex align-items-center justify-content-end text-nowrap"
    :class="isBookingFormNarrow ? 'justify-space-between w-100' : 'right-column'"
  >
    <div>
      <VBtn
        fab
        small
        class="box-shadow-elevation-6"
        :data-test="`decrease${dataTest}Button`"
        :disabled="amount === minValue || disabled"
        @click="updateValue(Number(amount) - 1)"
      >
        <VIcon>
          mdi-minus
        </VIcon>
      </VBtn>
    </div>
    <div
      class="mx-2"
      :class="isBookingFormNarrow && 'w-100'"
    >
      <ValidationProvider
        v-slot="{ errors, ariaInput }"
        :ref="`counter${validationProviderRef}`"
        :name="`counter${validationProviderRef}`"
        tag="div"
        :mode="mode"
        :rules="rules"
      >
        <VTextField
          v-bind="ariaInput"
          v-restrict:argument="maxValue"
          :data-test="`amount${dataTest}Field`"
          :value="amount"
          :disabled="disabled"
          :error="!!errors.length"
          :hide-details="true"
          align="center"
          :class="{ 'text-center': true, 'invalid': !!errors.length }"
          @input="newValue => updateValue(Number(newValue))"
        />
      </ValidationProvider>
    </div>
    <div>
      <VTooltip
        v-if="amount >= maxValue"
        :data-test="`maxAmount${dataTest}Tooltip`"
        bottom
        nudge-width="100"
        >
        <template v-slot:activator="{ on }">
          <div v-on="on" class="d-flex align-center">
            <VBtn
              fab
              small
              :data-test="`increase${dataTest}Button`"
              :disabled="amount >= maxValue || disabled"
              @click="updateValue(Number(amount) + 1)"
            >
              <VIcon>
                mdi-plus
              </VIcon>
            </VBtn>
          </div>
        </template>
        <span class="body-2">{{ hint }}</span>
      </VTooltip>
      <VBtn
        v-else
        fab
        small
        :data-test="`increase${dataTest}Button`"
        class="box-shadow-elevation-6"
        :disabled="amount >= maxValue || disabled"
        @click="updateValue(Number(amount) + 1)"
      >
        <VIcon>
          mdi-plus
        </VIcon>
      </VBtn>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'CustomCounter',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useVuetify } from '../../composables';

defineProps({
  icon: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
  featureId: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hint: {
    type: String,
    default: null,
  },
  amount: {
    type: Number,
    default: null,
  },
  maxForAllPassengers: {
    type: Number,
    default: null,
  },
  minValue: {
    type: Number,
    default: 0,
  },
  maxValue: {
    type: Number,
    default: 0,
  },
  rules: {
    type: Object,
    default: () => ({}),
  },
  mode: {
    type: String,
    default: 'aggressive',
  },
  dataTest: {
    type: String,
    default: '',
  },
  validationProviderRef: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['updateAmount']);
const vuetify = useVuetify();

const isBookingFormNarrow = computed(() => vuetify?.breakpoint.smAndDown);

function updateValue(newValue: number) {
  emit('updateAmount', newValue);
}
</script>

<style scoped>
.right-column {
  width: 40%;
}
.v-text-field {
  padding-top: 16px !important;
}

.v-input {
  margin-top: 4px !important;
  padding-top: unset !important;
  padding-bottom: unset !important;
}

.invalid >>> .v-text-field__slot input {
  color: var(--v-error-base);
}
</style>
